import find from 'lodash/find';
import isEmpty from 'lodash/isEmpty';
import includes from 'lodash/includes';
import xor from 'lodash/xor';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import styles from './RCUIMultipleSelect.scss';
import Icon from './Icon/index';

class MultipleSelect extends Component {
  constructor() {
    super();
    this.hideOptionList = this.hideOptionList.bind(this);
    this.showSelectedResult = this.showSelectedResult.bind(this);
    this.showSelectedOptions = this.showSelectedOptions.bind(this);
    this.reverseisOpen = this.reverseisOpen.bind(this);
    this.hasNothingSelected = this.hasNothingSelected.bind(this);
    this.isSelected = this.isSelected.bind(this);
    this.clearAll = this.clearAll.bind(this);
    this.toggleForOption = this.toggleForOption.bind(this);
    this.validOptions = this.validOptions.bind(this);
  }

  state = {
    isOpen: false,
  }

  componentDidMount() {
    document.addEventListener('click', this.hideOptionList);
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.hideOptionList);
  }

  hideOptionList(event) {
    if (this.state.isOpen) {
      let node = event && event.target;
      while (node && node !== this.wrapRef) {
        node = node.parentNode;
      }
      if (!node) {
        this.setState({ isOpen: false });
      }
    }
  }

  showSelectedResult() {
    if (this.hasNothingSelected()) {
      return (
        <span className={classnames(styles.selectResult, styles.defaultResult)}>
          {this.props.anyOptionValue}
        </span>
      );
    }

    return this.showSelectedOptions();
  }

  validOptions() {
    const {
      selectedOptions = [],
      options = [],
    } = this.props;

    return selectedOptions.map(value => find(options, { value })).filter(Boolean);
  }

  showSelectedOptions() {
    const validOptions = this.validOptions();
    const moreThanOneOption = validOptions.length > 1;

    return (
      <span className={styles.selectResult}>
        <span
          className={classnames(styles.selectedOptionWrapper, styles.firstOption, { [styles.marginWithPill]: moreThanOneOption })}
        >
          {validOptions[0].label}
        </span>
        { moreThanOneOption &&
          <span className={styles.more}>{validOptions.length - 1} more</span>
        }
      </span>
    );
  }

  reverseisOpen() {
    this.setState({ isOpen: !this.state.isOpen });
  }

  hasNothingSelected() {
    return isEmpty(this.validOptions());
  }

  isSelected(value) {
    return includes(this.props.selectedOptions, value);
  }

  clearAll(event) {
    event.preventDefault();
    this.props.onChange([]);
  }

  toggleForOption(option) {
    const { selectedOptions, onChange } = this.props;
    const updatedSelectedOptions =
      includes(selectedOptions, option) ?
        xor(selectedOptions, [option]) :
        selectedOptions.concat(option);
    return (event) => {
      event.preventDefault();
      onChange(updatedSelectedOptions);
    };
  }

  keyDownHandler = (event) => {
    switch (event.keyCode) {
      case 27: // Esc key
        this.hideOptionList();
        this.buttonRef.focus();
        break;
      default: break;
    }
  }

  render() {
    const { isOpen } = this.state;
    const isOpenClassName = isOpen ? styles.isOpen : '';
    const { anyOptionValue, options, className, hideDefault } = this.props;

    const getOptionsList = selectOptions => (
      selectOptions.map(option => (
        <li className={styles.optionItem} key={option.value}>
          <button onClick={this.toggleForOption(option.value)} className={styles.optionButton}>
            <span className={this.isSelected(option.value) ? styles.optionIconSelected : styles.optionIcon}>
              <Icon name="tick" />
            </span>
            {option.label}
          </button>
        </li>
      ))
    );

    return (
      <div
        className={classnames(styles.multipleSelect, isOpenClassName, className)}
        ref={(ref) => { this.wrapRef = ref; }}
        onKeyDown={this.keyDownHandler}
      >
        <button
          type="button"
          className={isOpen ? styles.selectedAreaOpen : styles.selectedArea}
          onClick={this.reverseisOpen}
          tabIndex="0"
          ref={(ref) => { this.buttonRef = ref; }}
        >
          {this.showSelectedResult()}
          <span className={this.state.isOpen ? styles.arrowIconDown : styles.arrowIcon}>
            <Icon name="chevronRight" />
          </span>
        </button>
        { this.state.isOpen &&
        <div className={styles.optionListWrapper} ref={(ref) => { this.optionsListRef = ref; }}>
          <ul className={styles.optionList}>
            { !hideDefault &&
              <li className={styles.defaultItem} key={anyOptionValue}>
                <button type="button" onClick={this.clearAll} className={styles.optionButton}>
                  <span className={this.hasNothingSelected() ? styles.optionIconSelected : styles.optionIcon}>
                    <Icon name="tick" />
                  </span>
                  {anyOptionValue}
                </button>
              </li>
            }
            {getOptionsList(options)}
          </ul>
        </div>
        }
      </div>
    );
  }
}

MultipleSelect.propTypes = {
  onChange: PropTypes.func.isRequired,
  options: PropTypes.array.isRequired,
  selectedOptions: PropTypes.array,
  anyOptionValue: PropTypes.string,
  className: PropTypes.string,
  hideDefault: PropTypes.bool,
};

export default MultipleSelect;
